import { PopoverPlacement } from "@idui/react-popover";
import { PersonAdd as PersonAddIcon } from "@mui/icons-material";
import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { DirectionEnum } from "@ryde/shared";

import { MuiButton } from "../../../../controls";
import { FramerTooltip } from "../../../tooltips";

export interface IButtonAddPassenger {
  watchedId: number | undefined;
  stationsChosen: boolean | undefined;
  direction: DirectionEnum | undefined;
  onClick: () => void;
}

export const ButtonAddPassenger: FC<IButtonAddPassenger> = ({
  watchedId,
  stationsChosen,
  direction,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <FramerTooltip
      content={
        !watchedId || !stationsChosen
          ? t("ride.PLEASE_CHOOSE_PASSENGER_FIRST")
          : startCase(t("general.ADD_NEW", { entity: t("passenger.single") }))
      }
      placement={PopoverPlacement.top}
    >
      {/* Prevent "A disabled element does not fire events." MUI error*/}
      <span>
        <MuiButton
          disabled={!watchedId || !stationsChosen || !direction}
          onClick={onClick}
          color="primary"
        >
          {t("ride.addPassengerStationPanel")}
          <PersonAddIcon />
        </MuiButton>
      </span>
    </FramerTooltip>
  );
};
